import { Link } from "react-router-dom";

import "./BreadCrumbsUI.css";

const BreadCrumbsUI = ({ items, className = "", separator = "/" }) => {
  return (
    <nav
      className={`breadcrumbsUi ${className}`}
      itemScope
      itemType="http://schema.org/BreadcrumbList"
    >
      {items.map((item, index) => (
        <div
          key={index}
          className="breadcrumbsUi__item"
          itemProp="itemListElement"
          itemScope
          itemType="http://schema.org/ListItem"
        >
          <Link to={item.link} itemProp="item">
            <span itemProp="name">{item.name}</span>
          </Link>
          <meta itemProp="position" content={(index + 1).toString()} />
          {index < items.length - 1 && (
            <span className="breadcrumbsUi__separator">{separator}</span>
          )}
        </div>
      ))}
    </nav>
  );
};

export default BreadCrumbsUI;
